export default "__VITE_ASSET__3a6bbaaa__"